import { FlatList, Image } from 'react-native';
import type { PlayerSquareProps, PublicPlayerProps } from "../../types";
import { Icons } from '../../Components';
import { SqauresHelpers } from '../api';
import React, { useState } from 'react';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';


type SquareOwnersCardProps = {
    player_squares:PlayerSquareProps[],
    players:PublicPlayerProps[],
    hidden?:boolean,
    disable_collapse?:boolean,
    onPlayerSelect:(player:PublicPlayerProps) => void
}
const SquareOwnersCard = ({ hidden, disable_collapse, player_squares, players, onPlayerSelect }:SquareOwnersCardProps) => {
    const C = useColors();
    const [ expanded, setExpanded ] = useState(false);

    const ownerships = SqauresHelpers.getOwnerShipPercents(player_squares);

    const renderOwners = (data:{ item: { player_id:string, owned_squares:number, owned_pct:number }, index:number }) => {
        const player = players.find(p => p.player_id == data.item.player_id);
        if(!player){  return <></> }
        return (
            <Button float style={{ margin:5, borderRadius:8, padding:0, maxWidth:150 }} onPress={() => onPlayerSelect(player)}>
                <Image
                    source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:100, width:100, borderRadius:4 }}
                    resizeMode='cover'
                />
                <View style={{ position:'absolute', left:0, right:0, bottom:0, borderRadius:4, backgroundColor:C.views.background }}>
                    <View transparent style={{ padding:10 }}>
                        <Text theme='h2'>@{player.username}</Text>
                    </View>
                    <View transparent style={{ position:'absolute', left:0, right:0, top:-15, justifyContent:'center', alignItems:'center' }}>
                        <View float style={{ height:30, width:30, borderRadius:100, justifyContent:'center', alignItems:'center' }}>
                            <Text theme='description' weight='bold'>{(data.item.owned_pct * 100).toFixed()}%</Text>
                        </View>
                    </View>
                </View>
            </Button>
                
        )
    }
    if(hidden){ return <></> }
    return (
        <View float style={{  minWidth:350, borderRadius:0 }}>
            <Button disabled={disable_collapse} transparent style={{ flexDirection:'row', alignItems:'center', backgroundColor:C.views.header, borderRadius:0 }} onPress={() => setExpanded(!expanded)}>
                <Icons.OwnedSquareIcon size={18} color={C.text.h1} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>SQUARE OWNERS</Text>
                    <Text style={{ marginTop:3 }} theme='description'>Players that own or have highest bid on at least 1 square</Text>
                </View>
                {!disable_collapse ?
                <Icons.ChevronIcon direction={expanded?'up':'down'} size={8} color={C.text.h1} />
                :<></>}
            </Button>
            {expanded ?
            <View style={{ padding:20 }}>
                <FlatList
                    data={ownerships}
                    renderItem={renderOwners}
                    horizontal
                    keyExtractor={(item) => item.player_id.toString()}
                />
            </View>
            :<></>}
        </View>   
    )
}

export default SquareOwnersCard